import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

const LoginLinkWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    ${breakpoint('xs', 'sm')`
        justify-content: center;
    `}
`;

export default LoginLinkWrapper;



// WEBPACK FOOTER //
// ./src/components/atoms/form/LoginLinkWrapper.js